/* eslint-disable no-bitwise */
/* eslint-disable react/prop-types */
/* global analytics */

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { withStyles } from "@material-ui/core/styles";
import Typeography from "@material-ui/core/Typography";
import axios from "axios";
import JsCookie from "js-cookie";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { CardElement, injectStripe } from "react-stripe-elements";

import Errors from "./Errors";
import Success from "./Success";

function createUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function track(event, props) {
  try {
    analytics.track(event, props);
  } catch (err) {
    console.log("analytics.js library not found");
  }
}

// eslint-disable-next-line
const toUnderscore = (str) =>
  str.replace(/([A-Z])/g, $1 => `_${$1.toLowerCase()}`);

const styles = theme => ({
  inputGroup: {
    marginBottom: theme.spacing(2),
  },
  fieldset: {
    marginBottom: theme.spacing(3),
  },
  cardElement: {
    padding: theme.spacing(2),
    border: "1px SOLID rgba(0, 0, 0, 0.23)",
    borderRadius: 4,
  },
  group: {
    flexDirection: "row",
  },
  wrapper: {
    position: "relative",
    display: "inline-block",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
});

const initialState = {
  cartId: createUUID(),
  orderId: createUUID(),
  senderName: "",
  senderEmail: "",
  recipientName: "",
  recipientEmail: "",
  message: "",
  amount: "50",
  stripeError: undefined,
  postError: undefined,
  purchaseDetails: {
    discount_code: "AAA-BBBB-CCCC",
    amount: 50,
    currency_symbol: "£",
    currency_code: "GBP",
  },
  purchaseComplete: false,
  sendToRecipient: "yes",
};

class GiftCardForm extends Component {
  state = {
    ...initialState,
  };

  componentDidMount() {
    this.trackCheckoutStarted();
  }

  async getStripeToken() {
    const { senderName } = this.state;
    const { stripe } = this.props;

    // create the stripe token
    const { token, error } = await stripe.createToken({
      name: senderName,
    });

    // check for errors and exit if so
    if (error) {
      this.setState({ paying: false, stripeError: error });
      throw Error("Could not get token");
    }

    return token;
  }

  getPostError(field) {
    const { postError } = this.state;
    try {
      return postError.detail[toUnderscore(field)];
    } catch (err) {
      return "";
    }
  }

  handleReset = () => {
    this.setState({ ...initialState });
  };

  handleChange = name => (event) => {
    if (name === "amount") {
      this.trackOrderUpdated(event.target.value);
    }
    this.setState({ [name]: event.target.value });
  };

  async buyGiftCard() {
    const {
      senderName,
      senderEmail,
      recipientName,
      recipientEmail,
      message,
      amount,
      sendToRecipient,
    } = this.state;

    let response;
    try {
      response = await axios.post(
        "/api/v3/giftcards/buy/",
        {
          sender_name: senderName,
          sender_email: senderEmail,
          recipient_name:
            sendToRecipient === "yes" ? recipientName || undefined : undefined,
          recipient_email:
            sendToRecipient === "yes" ? recipientEmail || undefined : undefined,
          message: sendToRecipient === "yes" ? message || undefined : undefined,
          amount,
        },
        {
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": JsCookie.get("csrftoken"),
          },
        },
      );
    } catch (err) {
      // eslint-disable-next-line prefer-destructuring
      response = err.response;
    }

    return response;
  }

  hasPostError(field) {
    const { postError } = this.state;
    try {
      return postError.detail[toUnderscore(field)] !== undefined;
    } catch (err) {
      return false;
    }
  }

  startPolling(orderID) {
    setTimeout(() => this.pollForAsyncResult(orderID), 3000);
  }

  trackCheckoutStarted() {
    const { orderId, amount } = this.state;
    track("Checkout Started", {
      order_id: orderId,
      value: amount,
      currency: "GBP",
      products: [
        {
          product_id: "GIFTCARD",
          name: "GIFTCARD",
          category: "Gift cards",
          sku: `GIFTCARD_${amount}`,
          price: amount,
          quantity: 1,
        },
      ],
    });
  }

  trackOrderUpdated(amount) {
    const { orderId } = this.state;
    track("Order Updated", {
      order_id: orderId,
      value: amount,
      currency: "GBP",
      products: [
        {
          product_id: "GIFTCARD",
          name: "GIFTCARD",
          category: "Gift cards",
          sku: `GIFTCARD_${amount}`,
          price: amount,
          quantity: 1,
        },
      ],
    });
  }

  trackOrderCompleted() {
    const { orderId, amount } = this.state;
    track("Order Completed", {
      order_id: orderId,
      value: amount,
      currency: "GBP",
      products: [
        {
          product_id: "GIFTCARD",
          name: "GIFTCARD",
          category: "Gift cards",
          sku: `GIFTCARD_${amount}`,
          price: amount,
          quantity: 1,
        },
      ],
    });
  }

  async pollForAsyncResult(orderID) {
    let response;

    try {
      response = await axios.get(`/api/v3/payments/order/${orderID}/`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      response = error.response; // eslint-disable-line

      this.setState({
        postError: { detail: "An unknown error occured, please try again." },
      });

      // release the pay button
      this.setState({ paying: false });
      return;
    }

    switch (response.data.status) {
      case "processing":
        // try again!
        this.startPolling(orderID);
        break;

      case "failed":
        this.setState({
          postError: {
            detail:
              "Something went wrong processing your card payment. Please try again.",
          },
          paying: false,
        });
        break;

      case "completed":
        this.setState({
          purchaseComplete: true,
          paying: false,
          purchaseDetails: {
            discount_code: response.data.output.code,
            amount: response.data.output.amount,
          },
        });
        this.trackOrderCompleted();
        break;

      default:
        this.setState({
          postError: { detail: "An unknown error occured, please try again." },
          paying: false,
        });
    }
  }

  async submit() {
    const { senderName, senderEmail } = this.state;

    const { stripe } = this.props;

    // update the state to remove errors and start any loading UI
    await this.setState({ stripeError: false, postError: false, paying: true });

    // Get stripe token.
    const token = await this.getStripeToken();

    // Make buy request.
    const buyResponse = await this.buyGiftCard();

    // If buy request returned 200:
    // - Start polling for order status.
    // - Try to confirm card payment.
    if (buyResponse.status === 200) {
      const { error } = await stripe.confirmCardPayment(
        // eslint-disable-line
        buyResponse.data.intent_client_secret,
        {
          payment_method: {
            card: {
              token: token.id,
            },
            billing_details: {
              name: senderName,
              email: senderEmail,
            },
          },
        },
      );

      if (error) {
        this.setState({
          paying: false,
          stripeError: {
            message:
              "Something went wrong processing your card payment. Please try again.",
          },
        });
      } else {
        this.startPolling(buyResponse.data.order);
      }
    } else {
      this.setState({ postError: buyResponse.data });
      this.setState({ paying: false });
    }
  }

  render() {
    const {
      senderName,
      senderEmail,
      recipientName,
      recipientEmail,
      message,
      amount,
      paying,
      stripeError,
      postError,
      purchaseDetails,
      purchaseComplete,
      sendToRecipient,
    } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <div
          className={classes.fieldset}
          ref={(ref) => {
            this.topEl = ref;
          }}
        >
          <Divider />
        </div>
        <Collapse in={purchaseComplete} mountOnEnter unmountOnExit>
          <Success
            handleReset={this.handleReset}
            discountCode={purchaseDetails.discount_code}
            amount={purchaseDetails.amount}
            currencySymbol={purchaseDetails.currency_symbol}
            currencyCode={purchaseDetails.currency_code}
          />
        </Collapse>
        <Collapse in={!purchaseComplete} mountOnEnter unmountOnExit>
          <ValidatorForm onSubmit={() => this.submit()}>
            <fieldset className={classes.fieldset}>
              <Typeography title variant="title">
                How much is this gift for?
              </Typeography>
              <Typeography paragraph>Minimum £5</Typeography>
              <TextValidator
                className={classes.inputGroup}
                label="Amount"
                variant="outlined"
                type="number"
                error={this.hasPostError("amount")}
                helperText={this.getPostError("amount")}
                fullWidth
                name="amount"
                validators={["required", "minNumber:5"]}
                errorMessages="The minimum gift card purchase is £5"
                value={amount}
                onChange={this.handleChange("amount")}
                InputProps={{
                  min: 5,
                  step: 1,
                  startAdornment: (
                    <InputAdornment position="start">£</InputAdornment>
                  ),
                }}
              />
            </fieldset>
            <fieldset className={classes.fieldset}>
              <Typeography title variant="title">
                Should we email the gift card to the lucky recipient or is this
                a surprise?
              </Typeography>

              <FormControl component="fieldset" className={classes.formControl}>
                <RadioGroup
                  aria-label="send-to-recipient"
                  name="sendToRecipient"
                  value={sendToRecipient}
                  onChange={this.handleChange("sendToRecipient")}
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio color="primary" />}
                    label="Yes please, send it to them."
                    className={classes.radioLabel}
                    labelPlacement="end"
                    fullWidth
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio color="primary" />}
                    label="No thanks, send it to me."
                    labelPlacement="end"
                    className={classes.radioLabel}
                    fullWidth
                  />
                </RadioGroup>
              </FormControl>
            </fieldset>
            <Collapse in={sendToRecipient === "yes"} mountOnEnter unmountOnExit>
              <fieldset className={classes.fieldset}>
                <Typeography title variant="title">
                  Their details
                </Typeography>
                <Typeography paragraph>
                  Who&apos;s getting all the love?
                </Typeography>
                <TextValidator
                  className={classes.inputGroup}
                  label="Their name"
                  variant="outlined"
                  type="text"
                  fullWidth
                  error={this.hasPostError("recipientName")}
                  helperText={this.getPostError("recipientName")}
                  name="recipientName"
                  validators={["required"]}
                  errorMessages="Please enter their name"
                  value={recipientName}
                  onChange={this.handleChange("recipientName")}
                />
                <TextValidator
                  className={classes.inputGroup}
                  label="Their email address"
                  variant="outlined"
                  type="email"
                  fullWidth
                  error={this.hasPostError("recipientEmail")}
                  helperText={this.getPostError("recipientEmail")}
                  name="recipientEmail"
                  value={recipientEmail}
                  onChange={this.handleChange("recipientEmail")}
                  validators={["required", "isEmail"]}
                  errorMessages="Please enter a valid email address"
                />
                <TextValidator
                  className={classes.inputGroup}
                  label="Your message"
                  variant="outlined"
                  type="text"
                  fullWidth
                  multiline
                  error={this.hasPostError("message")}
                  helperText={this.getPostError("message")}
                  rows={3}
                  name="message"
                  value={message}
                  onChange={this.handleChange("message")}
                />
              </fieldset>
            </Collapse>
            <fieldset className={classes.fieldset}>
              <Typeography title variant="title">
                Your details
              </Typeography>
              <Typeography paragraph>
                We will send you a receipt and instructions how to redeem the
                gift card.
              </Typeography>
              <TextValidator
                className={classes.inputGroup}
                label="Your name"
                variant="outlined"
                type="text"
                fullWidth
                name="senderName"
                value={senderName}
                error={this.hasPostError("senderName")}
                helperText={this.getPostError("senderName")}
                onChange={this.handleChange("senderName")}
                validators={["required"]}
                errorMessages="Please enter your name"
              />
              <TextValidator
                className={classes.inputGroup}
                label="Your email address"
                variant="outlined"
                type="email"
                fullWidth
                error={this.hasPostError("senderEmail")}
                helperText={this.getPostError("senderEmail")}
                name="senderEmail"
                value={senderEmail}
                onChange={this.handleChange("senderEmail")}
                validators={["required", "isEmail"]}
                errorMessages="Please enter a valid email address"
              />
            </fieldset>
            <fieldset className={classes.fieldset}>
              <Typeography title variant="title">
                Payment
              </Typeography>
              <Typeography paragraph>
                Your card will be processed securely. The details will not be
                stored.
              </Typeography>
              <CardElement className={classes.cardElement} />
            </fieldset>
            <fieldset className={classes.fieldset}>
              <div className={classes.wrapper}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={paying}
                >
                  Confirm and Pay
                </Button>
                {paying && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </fieldset>

            <Typeography>
              <a href="/customers/terms/much-better-gift-cards/">
                Terms &amp; Conditions Apply
              </a>
            </Typeography>
            {stripeError && (
              <Typeography color="error">{stripeError.message}</Typeography>
            )}
            {postError && <Errors postError={postError} />}
          </ValidatorForm>
        </Collapse>
      </div>
    );
  }
}

const GiftCardFormWithStyles = withStyles(styles)(GiftCardForm);

export default injectStripe(GiftCardFormWithStyles);
